import axios from "axios"

// Single-call v3 pipeline: OCR + LLM analysis.
function analyzeMaterial({}, formData) {
    return axios.post(`api/v2/materials/analyze`, formData)
}

function updateMaterialChapter({ id }, formData) {
    return axios.patch(`api/v2/materials/${id}/chapter`, formData)
}

// Re-run chapter detection on the already-stored transcript
// after the tutor accepts a subject/class correction suggestion — no new
// OCR call. Replaces the old /curriculum/search-based cross-class fallback.
function reanalyzeScope({ id }, formData) {
    return axios.patch(`api/v2/materials/${id}/reanalyze-scope`, formData)
}

function updateMaterial({ id }, formData) {
    return axios.put(`api/materials/${id}`, formData)
}

function completeManual({ id }, formData) {
    return axios.patch(`api/v2/materials/${id}/complete`, formData)
}

export const materialsService = {
    analyzeMaterial,
    updateMaterialChapter,
    reanalyzeScope,
    updateMaterial,
    completeManual,
}
